import React from "react";
import { Link } from "react-router-dom";

const logos = {
	icon: "/images/logos/blackadder-logo-icon.png",
	fullWhite: "/images/logos/blackadder-ticket-logo-typo-w.svg",
};

interface MobileHeaderProps {
	onMenuClick: () => void;
	isMenuOpen: boolean;
}

const MobileHeader: React.FC<MobileHeaderProps> = ({ onMenuClick, isMenuOpen }) => {
	return (
		<header className="text-white h-20 lg:hidden" style={{ backgroundColor: '#2a2a2a' }}>
			<div className="container mx-auto px-6 h-full">
				<div className="flex justify-between items-center h-full">
					<Link to="/" className="flex items-center space-x-3">
						<img
							className="h-10 shadow-md"
							src={logos.icon}
							alt="Blackadder Icon"
							width="auto"
						/>
						<img
							className="h-4"
							src={logos.fullWhite}
							alt="Blackadder"
							width="auto"
						/>
					</Link>

					{/* Mobile Menu Button */}
					<button onClick={onMenuClick} aria-label="メニュー" className="p-2">
						{isMenuOpen ? (
							<svg
								className="w-6 h-6"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						) : (
							<svg
								className="w-6 h-6"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="2"
									d="M4 6h16M4 12h16M4 18h16"
								/>
							</svg>
						)}
					</button>
				</div>
			</div>
		</header>
	);
};

export default MobileHeader;